// utils/Password.js

export const isValidPassword = (password) => {
    const minLength = parseInt(process.env.REACT_APP_PASSWORD_MIN_LENGTH, 10);
    const specialCharPattern =
      process.env.REACT_APP_PASSWORD_SPECIAL_CHARACTERS;

    const minLengthRegex = new RegExp(`.{${minLength},}`); // At least `minLength` characters
    const specialCharRegex = new RegExp(`${specialCharPattern}`); // At least one special character

    return minLengthRegex.test(password) && specialCharRegex.test(password);
}